import { ExportDataButton } from "components/ExportDataButton";
import { useCurrentUser } from "hooks/useCurrentUser";
import { useTenant } from "hooks/useTenant";

export function FacilitiesExportButton({
  tenantId,
  filter,
  iconOnly,
}: {
  tenantId?: string;
  filter?: Record<string, any>;
  iconOnly?: boolean;
}) {
  const { tenant } = useTenant();
  // Staff emulating a customer get the customer's columns
  const { isStaff: viewerIsStaff } = useCurrentUser();

  return (
    <ExportDataButton
      exportType="facilities"
      disabled={!tenantId}
      tenantId={tenantId ?? ""}
      fileName={tenant?.name ? `${tenant.name}-facilities` : "facilities"}
      filter={{ ...filter, viewerIsStaff }}
      iconOnly={iconOnly}
    />
  );
}
